import { render, staticRenderFns } from "./ColumnUser.vue?vue&type=template&id=c380563e"
import script from "./ColumnUser.vue?vue&type=script&lang=js"
export * from "./ColumnUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports